import { render, staticRenderFns } from "./PrintViewReports.vue?vue&type=template&id=bed10bd4"
import script from "./PrintViewReports.vue?vue&type=script&lang=js"
export * from "./PrintViewReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports